/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

export const AnimatedCoreElements = new URL('./temp-images/ww-animated-core-elements.gif', import.meta.url).href;
export const AnimatedEditorialPackages = new URL('./temp-images/ww-animated-editorial-packages.gif', import.meta.url).href;
export const AnimatedOnAirNavigation = new URL('./temp-images/ww-animated-on-air-navigation.gif', import.meta.url).href;
export const AnimatedPromoPackages = new URL('./temp-images/ww-animated-promo-packages.gif', import.meta.url).href;
export const CoreElementsImageTitle = new URL('./temp-images/ww-title-core-elements.jpg', import.meta.url).href;
export const EditorialPackagesImageTitle = new URL('./temp-images/ww-title-editorial-packages.jpg', import.meta.url).href;
export const LogoHarryPotter = new URL('./images/logo-harry-potter.png', import.meta.url).href;
export const OnAirNavigationImageTitle = new URL('./temp-images/ww-title-on-air-navigation.jpg', import.meta.url).href;
export const PromoPackagesImageTitle = new URL('./temp-images/ww-title-promo-packages.jpg', import.meta.url).href;
